import type { GetGeoLocationRequest } from './types';

export const DEVICE_QUERY_KEYS = {
  geoLocation: ({ ip }: GetGeoLocationRequest) => ['device', 'geo-location', ip] as const,
} as const;
